import React, { Component, PropTypes } from 'react';
import { Units } from 'Css';
import FormFieldContainer from './FormFieldContainer';

const toHex = number => {
  const str = number.toString(16).toUpperCase();
  const pad = '#000000';
  return pad.substring(0, pad.length - str.length) + str;
};

const css = oxygenCss({
  root: {
    margin: 'auto',
    width: `${(44 + Units.base) * 5}px`
  },
  color: {
    cursor: 'pointer',
    display: 'inline-block',
    position: 'relative',
    width: 44,
    height: 44,
    margin: Units.base / 2,
    boxSizing: 'border-box',
    '>DIV': {
      opacity: 0.5,
      boxSizing: 'border-box',
      height: 44,
      borderStyle: 'solid',
      borderWidth: '2px',
      borderColor: 'transparent'
    }
  }
});

class ColorChooser extends Component {
  static propTypes = {
    selected: PropTypes.string,
    title: PropTypes.string,
    onChange: PropTypes.func,
    colors: PropTypes.array
  };

  static defaultProps = {
    colors: [
      0xaa4245,
      0xadd356,
      0x4299aa,
      0x7342aa,
      0xaa9a42,
      0x000000,
      0x474747,
      0x636363,
      0x727272,
      0xffffff
    ]
  };

  handleTouchTap = color => {
    const { onChange, selected } = this.props;
    if (onChange) {
      onChange(color === selected ? null : color);
    }
  };

  render() {
    const { colors, title, selected } = this.props;
    return (
      <FormFieldContainer title={title}>
        <div className={css.root}>
          {colors.map(color => {
            const backgroundColor = toHex(color);
            const borderColor =
              selected === backgroundColor
                ? `${toHex(0xffffff ^ color)}`
                : 'transparent';
            return (
              <div
                key={color}
                className={css.color}
                style={{ backgroundColor }}
                onTouchTap={this.handleTouchTap.bind(this, backgroundColor)}
              >
                <div style={{ borderColor }} />
              </div>
            );
          })}
        </div>
      </FormFieldContainer>
    );
  }
}

export default ColorChooser;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/ColorChooser.js